interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
}

export function ErrorState({
  title = "加载失败",
  description = "请检查网络连接或稍后再试。",
  onRetry
}: ErrorStateProps): JSX.Element {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-red-50 p-6 text-center text-red-700">
      <div className="rounded-full bg-red-100 p-3 text-3xl">⚠️</div>
      <div>
        <h2 className="text-lg font-semibold">{title}</h2>
        <p className="mt-1 text-sm text-red-600">{description}</p>
      </div>
      {onRetry ? (
        <button
          type="button"
          onClick={onRetry}
          className="rounded bg-red-600 px-4 py-2 text-sm font-medium text-white shadow hover:bg-red-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2"
        >
          重试
        </button>
      ) : null}
    </div>
  );
}
